import { FormControl } from "@angular/forms";
//pass imn the function, so isLackOfInventory will always get the latest value
export function c2keepPartialAddedQtyValidator(isLackOfInventoryFn: () => boolean, control: FormControl): any {
    if (!control?.value && isLackOfInventoryFn()) {
        return { required: true };
    }
    return null;
}